import { render, staticRenderFns } from "./UiCalendarMonth.vue?vue&type=template&id=408958f0"
import script from "./UiCalendarMonth.vue?vue&type=script&lang=js"
export * from "./UiCalendarMonth.vue?vue&type=script&lang=js"
import style0 from "./UiCalendarMonth.vue?vue&type=style&index=0&id=408958f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports